import script from "./viewDefibrillator.vue?vue&type=script&setup=true&lang=js"
export * from "./viewDefibrillator.vue?vue&type=script&setup=true&lang=js"

import "./viewDefibrillator.vue?vue&type=style&index=0&id=12015c9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12015c9c"]])

export default __exports__